import {
	Button,
	Dialog,
	DialogActions,
	DialogContent,
	DialogContentText,
	DialogTitle,
	Divider,
	Menu,
	MenuItem,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TableRow
} from '@mui/material'
import { useApp } from 'core/contexts/profile.context'
import React, { useState } from 'react'
import { useMutation, useQuery } from 'react-query'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { deleteTicketTypes, getTicketsTypes } from 'services/ticketTypes/tickets-types.service'

import { Cancel, Dots, Edit, Settings, View } from '../../core/icons'

export const TicketsTypeTableComponent = () => {
	const navigate = useNavigate()
	const { profile } = useApp()
	const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
	const open = Boolean(anchorEl)
	const [openModal, setOpenModal] = React.useState(false)
	const handleOpenModal = () => setOpenModal(true)
	const handleCloseModal = () => setOpenModal(false)
	const [currentId, setCurrentId] = useState<any>()

	const { data: types, refetch } = useQuery(['getTicketsTypes'], {
		queryFn: () => getTicketsTypes()
	})
	const deleteStaffMutate = useMutation({
		mutationFn: (type_id: any) => deleteTicketTypes(type_id),
		onSuccess: () => {
			toast.success('Successfully deleted')
			setOpenModal(false)
			setAnchorEl(null)
			refetch()
		}
	})
	const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
		setCurrentId(event.currentTarget.id)
		setAnchorEl(event.currentTarget)
	}
	const handleClose = () => {
		setAnchorEl(null)
	}
	const handleStaffsDelete = () => {
		deleteStaffMutate.mutate(currentId)
	}
	const handleEditStuff = () => {
		navigate(`/tickets/type/${currentId}?edit`)
	}
	const handleViewTicketType = () => {
		navigate(`/tickets/type/${currentId}?view`)
	}
	return (
		<div>
			<TableContainer component={Paper}>
				<Table sx={{ minWidth: 650 }} aria-label='simple table'>
					<TableHead>
						<TableRow>
							<TableCell>№</TableCell>
							<TableCell align='left'>Наименование</TableCell>
							<TableCell align='left'>Возраст от</TableCell>
							<TableCell align='left'>Возраст до</TableCell>
							<TableCell align='left'>Пол</TableCell>
							<TableCell align='left'>Детский</TableCell>
							<TableCell align='left'>Вип</TableCell>
							<TableCell align='right'>
								<Settings />
							</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{types?.data &&
							types.data.map((row: any) => (
								<TableRow
									key={row.id}
									sx={{
										'&:last-child td, &:last-child th': {
											border: 0
										}
									}}
								>
									<TableCell component='th' scope='row'>
										{row.id}
									</TableCell>
									<TableCell align='left'>{row.name}</TableCell>
									<TableCell align='left'>{row.age_from}</TableCell>
									<TableCell align='left'>{row.age_to}</TableCell>
									<TableCell align='left'>{row.gender === 'male' ? 'Мужской' : 'Женский'}</TableCell>
									<TableCell align='left'>{row.is_kids ? 'Да' : 'Нет'}</TableCell>
									<TableCell align='left'>{row.is_vip ? 'Да' : 'Нет'}</TableCell>
									<TableCell align='right'>
										<Button
											id={row.id}
											aria-controls={open ? 'basic-menu' : undefined}
											aria-haspopup='true'
											aria-expanded={open ? 'true' : undefined}
											onClick={handleClick}
										>
											<Dots />
										</Button>
										<Menu
											id={`basic-menu-${row.id}`}
											anchorEl={anchorEl}
											open={open}
											onClose={handleClose}
											MenuListProps={{
												'aria-labelledby': 'basic-button'
											}}
										>
											<MenuItem onClick={handleViewTicketType} key={`menu-item-${row.id}`}>
												<View
													style={{
														color: '#349EFF',
														marginRight: '8px'
													}}
												/>
												Просмотр типа билета
											</MenuItem>
											<Divider />
											{profile?.user?.role.permissions.includes('update_ticket_type') && (
												<MenuItem onClick={handleEditStuff} key={`menu-item-${row.id}`}>
													<Edit
														style={{
															marginRight: '8px'
														}}
													/>
													Редактировать
												</MenuItem>
											)}
											<Divider />
											{profile?.user?.role.permissions.includes('update_ticket_type') && (
												<MenuItem onClick={handleOpenModal}>
													<Cancel
														style={{
															marginRight: '8px'
														}}
													/>
													Удалить
												</MenuItem>
											)}
										</Menu>
									</TableCell>
									<Dialog
										open={openModal}
										onClose={handleCloseModal}
										aria-labelledby='alert-dialog-title'
										aria-describedby='alert-dialog-description'
									>
										<DialogTitle id='alert-dialog-title'>Вы уверены?</DialogTitle>
										<DialogContent>
											<DialogContentText id='alert-dialog-description'>
												Прежде чем удалить, убедитесь в том что данные удалятся безвозвратно и
												без сохранении
											</DialogContentText>
										</DialogContent>
										<DialogActions
											sx={{
												display: 'flex',
												flexDirection: 'column',
												alignItems: 'end'
											}}
										>
											<Button
												onClick={handleCloseModal}
												variant='text'
												color='success'
												style={{ marginBottom: '16px' }}
											>
												Нет, оставить
											</Button>
											<Button onClick={handleStaffsDelete} autoFocus variant='text' color='error'>
												Да, удалить
											</Button>
										</DialogActions>
									</Dialog>
								</TableRow>
							))}
					</TableBody>
				</Table>
			</TableContainer>
		</div>
	)
}
